<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [noChangeLabel]="true"
  [areaName]="areaName"
  [model]="model"
  [erroremessage]="erroremessage"
  [samePermission]="true"
  [label]="label"
  savingLabel="درحال قطعی کردن اسناد"
  saveLabel="قطعی کردن اسناد"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <ng-container class="content">
    <date-picker
      id="dpVoucherDate"
      [defaultHeight]="30"
      [group]="formGroup"
      name="VoucherDate"
      label="تا تاریخ"
      [required]="true"
      textType="text"
      [disabled]="false">
    </date-picker>
    <h4 class="message">در صورت قطعی شدن اسناد دیگر قابل برگشت نخواهد بود.</h4>
  </ng-container>
</dynamic-form>
